import { createRouter, createWebHistory } from 'vue-router';

const routes = [
    {
        path: '/',
        name: '',
        component: () => import('../views/public/HomeView.vue')
    },
    {
        path: '/home',
        name: 'HomeView',
        component: () => import('../views/public/HomeView.vue')
    },
    {
        path: "/login",
        name: "LoginView",
        component: () => import("../views/public/LoginView.vue"),
    },
    {
        path: "/change-profile",
        name: "ChangeProfileView",
        component: () => import("../views/admin/setting/ChangeProfileView.vue"),
    },

    // ADMIN
    {
        path: '/admin-sistem',
        name: 'AdminSistemView',
        component: () => import('../views/admin/setting/UserView.vue')
    },
    {
        path: '/admin-struktur-organisasi-sistem',
        name: 'AdminStrukturSistemView',
        component: () => import('../views/admin/setting/StrukturSistemView.vue')
    },
    {
        path: '/admin-setting',
        name: 'AdminSetting',
        component: () => import('../views/admin/setting/SettingView.vue')
    },
    {
        path: '/cust-region',
        name: 'AdminWilayahView',
        component: () => import('../views/admin/mitra/WilayahView.vue')
    },
    {
        path: '/customer-old',
        name: 'AdminCustomerOld',
        component: () => import('../views/admin/mitra/CustomerView.vue')
    },
    {
        path: '/customer-new',
        name: 'AdminCustomerNewView',
        component: () => import('../views/admin/mitra/NewCustomerView.vue')
    },
    {
        path: '/customer-new-detil/:id',
        name: 'AdminCustomerNewDetilView',
        component: () => import('../views/admin/mitra/CustomerDetilView.vue')
    },

    {
        path: '/product-sales-chart-brand',
        name: 'AdminSalesBrandView',
        component: () => import('../views/admin/product/SalesBrandView.vue')
    },
    {
        path: '/admin-master-tax',
        name: 'AdminTaxView',
        component: () => import('../views/admin/product/TaxView.vue')
    },
    {
        path: '/cust-category',
        name: 'AdminCustCategoryView',
        component: () => import('../views/admin/mitra/KategoriView.vue')
    },
    {
        path: '/product-category',
        name: 'AdminProductGroupView',
        component: () => import('../views/admin/product/MaterialGroupView.vue')
    },
    {
        path: '/pegawai',
        name: 'SalesmanView',
        component: () => import('../views/admin/sales/SalesmanView.vue')
    },
    {
        path: '/sales-call-plan',
        name: 'SalesCallPlanView',
        component: () => import('../views/admin/sales/CallPlanView.vue')
    },
    {
        path: '/sales-call-plan-detil/:id',
        name: 'SalesCallPlanDetilView',
        component: () => import('../views/admin/sales/CallPlanDetilView.vue')
    },
    {
        path: '/sales-call-activity',
        name: 'SalesCallActivityView',
        component: () => import('../views/admin/sales/CallActView.vue')
    },

    {
        path: '/supplier',
        name: 'VendorView',
        component: () => import('../views/admin/mitra/VendorView.vue')
    },
    {
        path: '/product',
        name: 'MaterialView',
        component: () => import('../views/admin/product/MaterialView.vue')
    },
    {
        path: '/warehouse',
        name: 'WarehouseView',
        component: () => import('../views/admin/inventory/WarehouseView.vue')
    },
    {
        path: '/mobile-order-entry',
        name: 'CloudMobileView',
        component: () => import('../views/admin/cloud-mobile/CloudMobileView.vue')
    },
    {
        path: '/export-cloud-sales-chart-order',
        name: 'ExportOrderView',
        component: () => import('../views/admin/cloud-mobile/ExportOrderView.vue')
    },
    {
        path: '/sales-order-invoice',
        name: 'OrderInvoiceView',
        component: () => import('../views/admin/sales/OrderInvoiceView.vue')
    },
    {
        path: '/saldo-stock',
        name: 'AdminSaldoStock',
        component: () => import('../views/admin/inventory/StockView.vue')
    },
    {
        path: '/warning-stock',
        name: 'AdminWarningStock',
        component: () => import('../views/admin/utils/UnderConstructionView.vue')
    },
    {
        path: '/umur-stock',
        name: 'AdminUmurStock',
        component: () => import('../views/admin/utils/UnderConstructionView.vue')
    },
    {
        path: '/tax-keluaran',
        name: 'AdminTaxKeluaran',
        component: () => import('../views/admin/utils/UnderConstructionView.vue')
    },
    {
        path: '/sales-chart-delivery',
        name: 'AdminSalesDelivery',
        component: () => import('../views/admin/utils/UnderConstructionView.vue')
    },
    {
        path: '/export-sales-chart-detil',
        name: 'ExportSalesDetil',
        component: () => import('../views/admin/sales/ExportSalesDetilView.vue')
    },
    {
        path: '/sales-chart-summary-product',
        name: 'AdminSalesSummaryProduct',
        component: () => import('../views/admin/utils/UnderConstructionView.vue')
    },
    {
        path: '/log-exim',
        name: 'AdminLogEximView',
        component: () => import('../views/admin/cloud-mobile/LogEximView.vue')
    },
    {
        path: '/sastro-log-ext-check',
        name: 'SastroLogExtCheckView',
        component: () => import('../views/admin/cloud-mobile/SastroLogExtCheckView.vue')
    },

    {
        path: '/dashboard-utama',
        name: 'DashboardAdminDashboardUtama',
        component: () => import('../views/admin/dashboard/DashboardView.vue')
    },
    {
        path: '/dashboard-sales-list',
        name: 'DashboardAdminSalesListView',
        component: () => import('../views/admin/dashboard/SalesListView.vue')
    },
    {
        path: '/dashboard-salesman-performance',
        name: 'DashboardAdminSalesmanPerformanceView',
        component: () => import('../views/admin/dashboard/SalesmanPeformanceView.vue')
    },
    {
        path: '/dashboard-division-performance',
        name: 'DashboardAdminDivisionPerformanceView',
        component: () => import('../views/admin/dashboard/DivisionPeformanceView.vue')
    },
    {
        path: '/dashboard-ar-persalesman',
        name: 'DashboardArPerSalesmanView',
        component: () => import('../views/admin/dashboard/ArPerSalesmanView.vue')
    },

    {
        path: '/analisis-ldh-cash-analisis',
        name: 'LdhCashAnalisisView',
        component: () => import('../views/admin/distributor-analisis/LdhCashAnalisisView.vue')
    },

    {
        path: '/public-peta-sales-call',
        name: 'PetaPersebaranView',
        component: () => import('../views/public/PetaSalesCallView.vue')
    },


];

const router = createRouter({
    history: createWebHistory(process.env.BASE_URL),
    routes,
});

export default router;